// extracted by mini-css-extract-plugin
module.exports = {"root":"Counter_root__2hVGs","button":"Counter_button__3DWPw","text":"Counter_text__1UB1W"};